import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/DemoView.vue"),
    meta: { title: "Home" },
  },
  {
    path: "/demo",
    name: "Demo",
    component: () => import("../views/DemoView.vue"),
    meta: { title: "Demo" },
  },
  {
    path: "/about",
    name: "About",
    component: () => import("../views/AboutView.vue"),
    meta: { title: "About" },
  },
  {
    path: "*",
    name: "NotFound",
    component: () => import("../views/NotFoundView.vue"),
    meta: { title: "Not Found" },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// Set document title dynamically based on route
router.afterEach((to) => {
  const title = to.meta.title || "Page";
  document.title = `${title} - ifCharge`;
});

export default router;
